import { render, staticRenderFns } from "./WorkspaceFabricVisualize.vue?vue&type=template&id=7db32fe6&scoped=true&"
import script from "./WorkspaceFabricVisualize.vue?vue&type=script&lang=js&"
export * from "./WorkspaceFabricVisualize.vue?vue&type=script&lang=js&"
import style0 from "./WorkspaceFabricVisualize.vue?vue&type=style&index=0&id=7db32fe6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7db32fe6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7db32fe6')) {
      api.createRecord('7db32fe6', component.options)
    } else {
      api.reload('7db32fe6', component.options)
    }
    module.hot.accept("./WorkspaceFabricVisualize.vue?vue&type=template&id=7db32fe6&scoped=true&", function () {
      api.rerender('7db32fe6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/Workspace/WorkspaceFabricVisualize.vue"
export default component.exports